/**
 * Normalise any axios / FastAPI error into a safe string suitable for toast.error.
 * FastAPI 422 returns detail as an array of {msg, loc, ...} — rendering that
 * object directly inside a toast crashes React (Objects are not valid as a React child).
 */
export function apiError(e, fallback = "Erro") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((it) => (typeof it === "string" ? it : it?.msg || JSON.stringify(it))).join(" · ") || fallback;
  }
  if (typeof d === "object") return d.msg || JSON.stringify(d);
  return fallback;
}
